<template>
    <div class="navigation">
        <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>

            <el-col :span="6">
                <div class="logo">
                    <img src="../assets/logo.png">
                </div>
                <div class="title">
<!--                    <p class="name">GONG Qing</p>-->

                    <p class="info">龚卿 PH.D ，Zhejiang University</p>
                </div>
            </el-col>
            <el-col :span="2">

            </el-col>
            <el-col :span="1"><div class="grid-content">  </div> </el-col>
            <el-col :span="8">
                <el-menu
                         :default-active="activeIndex"
                        class="grid-content"
                        mode="horizontal"
                        text-color="#999"
                        active-text-color="#000"
                >

                        <el-menu-item style="margin:0 20px" index="1"> <a href="#/"  class="navigation-text"><div class="navigation-text-text">RESEARCH / PROJECTS</div></a></el-menu-item>
                        <el-menu-item style="margin:0 20px" index="2"> <a href="#/about"  class="navigation-text"><div class="navigation-text-text">ABOUT</div></a></el-menu-item>
                        <el-menu-item style="margin:0 20px" index="3"><a href="#/cv" class="navigation-text"><div class="navigation-text-text">CV</div></a></el-menu-item>
                        <el-menu-item style="margin:0 20px" index="4"><a href="#/media" class="navigation-text"><div class="navigation-text-text">MEDIA</div></a></el-menu-item>
                </el-menu>
            </el-col>
            <el-col :span="1"><div class="grid-content">  </div> </el-col>
            <el-col :span="2">
                <el-dropdown class="dropdown grid-content" trigger="click">
                      <span class="el-dropdown-link" onclick="showEnglish()" >
                          English<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item >
                              <span class="el-dropdown-link" onclick="showEnglish()">
                             Sorry! English Only
                              </span>
                    </el-dropdown-item>
                </el-dropdown-menu>
                </el-dropdown>
            </el-col>
            <el-col :span="2"><div class="grid-content">  </div></el-col>
        </el-row>
    </div>

</template>

<script>
    export default {
        name: "Header",
        data() {
            return {
                activeIndex: '1',
            };
        },

        showEnglish(){
            document.getElementById("English").style.display = "block";
            document.getElementById("Chinese").style.display = "none";
        },
        showChinese(){
            document.getElementById("English").style.display = "none";
            document.getElementById("Chinese").style.display = "block";
        }
    }
</script>

<style scoped>

    .logo{

    }
    .logo img{
        width: 20vw;

    }
    .navigation-text-text{
        margin: 20px -20px;
        text-align: center;
    }
    .name{
        font-size: 40px;
        font-weight: 900;
        letter-spacing: 3px;
        z-index:999;
    }
    .info{
        color: #aaa;
        font-weight: 200;
        font-size:15px;
        margin-top:-40px;
        letter-spacing:1px;
        z-index:999;
    }
    .title{
        min-height: 36px;
        border:none;
        margin-top: 40px;
        z-index:999;
    }
    .dropdown{
        min-height: 36px;
        margin: 40px 0 0 0;
    }
    .navigation-text {
        text-decoration:none;
        font-size:10px
    }
    .navigation {
        margin-top: 80px;
    }
    .grid-content {
        min-height: 36px;
       border:none;
        float: right;

    }
    .el-dropdown-link {
        cursor: pointer;
        color: #000;
    }
    .el-icon-arrow-down {
        font-size: 12px;
    }

</style>